import GetSchemasUseCase from './GetSchemasUseCase';
export function getSchemasUseCase(){
    return new GetSchemasUseCase();
}
